import { render, staticRenderFns } from "./textSelect.vue?vue&type=template&id=395b8ed2"
import script from "./textSelect.vue?vue&type=script&lang=js"
export * from "./textSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports